import {
  AuthUserResponse,
  ResendOtpEmailInputData,
  ResendOtpEmailV2InputData,
  SignInInputData,
  SignInResponse,
  SignInV2InputData,
  SignInV2Response,
  VerifySmsInputData,
} from '../types/api/auth.types';
import { isAdmin } from '../helpers/appType';
import { ResponseType } from '../types/shared.types';
import { api } from './api';

/**
 * The dev partner API. The admin dev API has no `get-login-otp` route, but
 * both read the same OTP store, so admin asks this one for its code too.
 */
const DEV_CUSTOMER_API = 'https://customer-331fd0a-api.vgrubs.com';

export const signIn = async (data: SignInInputData) => {
  return api.post<SignInResponse>('/v1/auth/sign-in', data);
};

export const resendOtpEmail = async (data: ResendOtpEmailInputData) => {
  return api.post<ResponseType<null>>('/v1/auth/resend-otp-email', data);
};

/** Merchant sign in / sign up by number alone; see SignInV2InputData. */
export const signInV2 = async (data: SignInV2InputData) => {
  return api.post<SignInV2Response>('/v2/auth/sign-in', data);
};

export const resendOtpEmailV2 = async (data: ResendOtpEmailV2InputData) => {
  return api.post<ResponseType<null>>('/v2/auth/resend-otp-email', data);
};

/**
 * The live code for a number, so QA needs no phone. Dev backend only;
 * production does not have the route. The body is an empty object, not
 * `null`: axios sends `null` as a JSON body and the backend's parser refuses
 * it ("Unexpected token n in JSON").
 */
export const getDevLoginOtp = async (phoneNumber: string) => {
  const host = isAdmin ? DEV_CUSTOMER_API : '';
  return api.post<ResponseType<string>>(
    `${host}/v1/auth/get-login-otp`,
    {},
    { params: { phoneNumber } }
  );
};

export const verifySms = async (data: VerifySmsInputData) => {
  return api.post<ResponseType<AuthUserResponse>>('/v1/auth/verify-sms', data);
};

export const refreshTokenCall = async () => {
  return api.post<{ accessToken: string }>('/v1/auth/refresh');
};

export const verifyEmail = async (id: number | string) => {
  return api.post<ResponseType<null>>(`/v1/auth/${id}/verify-email`);
};
